import { createAppStore } from '@store/createAppStore';
import { UserInfoModel } from '@store/orders';
import { FlagViewModel } from '@typeDefinitions/flagTypes';

type LoadInfoStoreT = {
  assignedTo: UserInfoModel | undefined;
  coveredBy: UserInfoModel | undefined;
  capacityOpsRepUser: UserInfoModel | undefined;
  isLoading: boolean;
  assignedToButton: string;
  flag: FlagViewModel | undefined;
  flagIndex: number | null;
};

export const [loadInfoStore, setLoadInfoStore] = createAppStore<LoadInfoStoreT>(
  {
    assignedTo: undefined,
    coveredBy: undefined,
    capacityOpsRepUser: undefined,
    isLoading: false,
    assignedToButton: 'Reassign',
    flag: undefined,
    flagIndex: null,
  },
  'loadInfoStore',
);
